
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningLightSleetShowersNightColour as ObiLightningLightSleetShowersNightColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-light-sleet-showers-night-colour.js';
 
 
 

 
 export const ObiLightningLightSleetShowersNightColour = createComponent({
   react: React,
   tagName: 'obi-lightning-light-sleet-showers-night-colour',
   elementClass: ObiLightningLightSleetShowersNightColourElement,
   events: {
     
   }
  });
 
 